import { IWaterMeterModel } from "../Types/WaterMeterTypes";

/**
 * Fetches all water meter data for the user.
 * @param municipalKey string determing municipality.
 * @param token oidc access token.
 * @param ownerId string of numbers 11(ssn) or 9(organisation number) digits long.
 */
async function getWaterSewageData(
  municipalKey: string,
  token: string,
  ownerId: string
): Promise<IWaterMeterModel[]> {
  let url = `${import.meta.env.VITE_DATA_API}/api/watersewage/water-meter/${encodeURIComponent(municipalKey)}`;

  if (ownerId.trim().length === 9)
  url = `${import.meta.env.VITE_DATA_API}/api/watersewage/water-meter/${encodeURIComponent(municipalKey)}?organizationNumber=${encodeURIComponent(ownerId)}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return await response.json();
}

export { getWaterSewageData };
